import { CURRENT_USER_HAS_APP_PASSWORD, SAVE_APP_PASSWORD, TEST_APP_PASSWORD, GET_USER_APP_PASSWORD_STATUS, REMOVE_USER_APP_PASSWORD } from "../constants";
import Requests from "../requests";

const AppPasswordService = {
    saveAppPassword,
    currentUserHasAppPassword,
    testAppPassword,
    getUserAppPasswordStatus,
    removeUserAppPassword
}

function currentUserHasAppPassword() {
    return Requests.getWithAuth(CURRENT_USER_HAS_APP_PASSWORD);
}

function saveAppPassword({ account, password }) {
    return Requests.postWithAuth(SAVE_APP_PASSWORD, { account, password });
}

function testAppPassword({ account, password }) {
    return Requests.postWithAuth(TEST_APP_PASSWORD, { account, password });
}

function getUserAppPasswordStatus(userId) {
    const url = GET_USER_APP_PASSWORD_STATUS.replace(':userId', userId);
    return Requests.getWithAuth(url);
}

function removeUserAppPassword(userId) {
    const url = REMOVE_USER_APP_PASSWORD.replace(':userId', userId);
    return Requests.deleteWithAuth(url);
}

export default AppPasswordService;